import { Media } from '@/models/media.model';
import mitt from 'mitt';

export enum Event {
  BeforeLanguageChange = 'BeforeLanguageChange',
  LanguageChanged = 'LanguageChanged',
  DrawerClosed = 'DrawerClosed',
  UseMedia = 'UseMedia',
  UpdateMedia = 'UpdateMedia',
  UpdateContentItem = 'UpdateContentItem',
  Saved = 'Saved',
}
export type Events = {
  [Event.BeforeLanguageChange]: void;
  [Event.LanguageChanged]: string;
  [Event.DrawerClosed]: null;
  [Event.UseMedia]: Media;
  [Event.UpdateMedia]: Media;
  [Event.Saved]: boolean;
  [Event.UpdateContentItem]: void;
};

const eventStore = mitt<Events>();

export const useEvents = () => {
  return eventStore;
};
